import type {
    StickerBadgeMappingConstantType,
    StickerIconPositionType,
    StickerIconPosition
} from "./type";
import type IBadgeProps from "../badge/type";

export const STICKER_ICON_POSITIONS: Record<StickerIconPositionType, StickerIconPosition> = {
    start: "start",
    left: "start",
    right: "end",
    end: "end"
};

export const getBadgePropsFromSticker = ({
    props
}: StickerBadgeMappingConstantType): IBadgeProps => {
    const {
        size = "medium",
        iconPosition,
        ...badgeProps
    } = props;

    if(!iconPosition) {
        return {
            ...badgeProps,
            size
        };
    }

    return {
        ...badgeProps,
        iconPosition: STICKER_ICON_POSITIONS[iconPosition],
        size
    };
};
